import { useTranslation } from 'react-i18next';
import { isSameDay, format, isYesterday } from 'date-fns';
import PropTypes from 'prop-types';

const LastAtMessage = ({ lastAt }) => {
  const { t } = useTranslation('components', { keyPrefix: 'ContactList.lastAt' });
  let message;

  if (isSameDay(lastAt)) {
    message = format(lastAt, 'hh:mm');
  } else if (isYesterday(lastAt)) {
    message = t('yesterday');
  } else {
    message = format(lastAt, 'DD.MM.YYYY');
  }

  return message;
};

LastAtMessage.propTypes = {
  lastAt: PropTypes.string.isRequired,
};

export default LastAtMessage;
